/* TODO: t() */
import React, { Fragment } from 'react';
import { View, StyleSheet, ViewProps } from 'react-native';

import LoadingIndicator from './LoadingIndicator';
import Separator from './Separator';
import Text from './Text';

type Props = ViewProps & {
  isLoading?: boolean;
  children?: React.ReactNode;
};

// TODO: Accept action like addAccount in header
// and possibly do action using context
type HeaderProps = {
  children?: React.ReactNode;
  title: string;
  showSeparator: boolean;
  style?: StyleSet;
  headerStyle?: StyleSet;
};

let styles = StyleSheet.create({
  root: {
    flex: 1,
    margin: 30,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    zIndex: 1,
  },
  headerContent: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  separator: {
    marginBottom: 20,
  },
});

function Header(props: HeaderProps) {
  return (
    <Fragment>
      <View style={[styles.header, props.headerStyle]}>
        <Text type="title">{props.title}</Text>
        <View style={[styles.headerContent, props.style]}>
          {props.children}
        </View>
      </View>
      {props.showSeparator && <Separator style={styles.separator} />}
    </Fragment>
  );
}

Header.defaultProps = {
  showSeparator: true,
};

function Page(props: Props) {
  let { isLoading, style, ...otherProps } = props;
  if (isLoading) {
    return (
      <View style={[styles.root, style]}>
        <LoadingIndicator />
      </View>
    );
  }

  return <View style={[styles.root, style]} {...otherProps} />;
}

Page.Header = Header;

export default Page;
